/**
 * Valeur à passer à **`DefaultDashboardWithList`** en **`sidebarCompactSearch`** pour les vues dont la colonne
 * gauche est une **`SearchBlockList`** (liste + recherche). Active **`SearchBlockList` → `SearchBar` `compact`**.
 */
export const SIDEBAR_LIST_COMPACT_SEARCH = true;
